import Modal from 'react-modal'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { ReactComponent as ModalXIcon } from '../../../assets/images/common/icons/modal-X-icon.svg'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'
import SubmitButton from '../../common/buttons/SubmitButton'

import classes from './DeleteAccountModal.module.scss'
import Input from '../../common/form/Input'

const DeleteAccountModal = ({ user, isOwnAccount, showModal, closeModal, password, passwordError, handlePasswordChange, handleDeleteAccount }) => {
  const { t } = useTranslation()
  const lastFamilyAdmin = user.is_last_family_admin

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel={t('account.deleteModal.contentLabel')}
      className={classes.deleteAccountModalContent}
      autoFocus
    >
      <div className='animated fadeIn'>
        <div className='d-flex justify-content-end text-align-right'>
          <ModalXIcon className={classes.modalXIcon} onClick={closeModal} />
        </div>
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <WarningIcon className={classes.warningIcon} />
          <h6 className={classNames(classes.title, 'mb-3')}>{t('account.common.deleteAccount')}</h6>

          {lastFamilyAdmin && (
            <p className={classNames('text-center', classes.warningMessage)}>
              {t('account.deleteModal.lastAdminWarning')}
            </p>
          )}

          <p className={classNames('text-center', classes.message)}>
            {
              isOwnAccount
                ? t('account.deleteModal.passwordRequired')
                : t('account.deleteModal.passwordRequiredJunior')
            }
          </p>
        </div>
        <label htmlFor='password' className='my-2 font-weight-bold'>
          {t('common.field.password')} <span className='required-text'>*</span>
        </label>
        <Input
          name='password'
          type='password'
          value={password}
          onChange={handlePasswordChange}
          placeholder={isOwnAccount ? t('account.deleteModal.passwordPlaceholder') : t('account.deleteModal.passwordPlaceholderJunior')}
          error={passwordError}
        />
        <div className='row py-3'>
          <div className='col-12'>
            <SubmitButton
              onClick={handleDeleteAccount}
              buttonMessage={lastFamilyAdmin ? t('account.deleteModal.deleteAccountAndMembers') : t('account.common.deleteAccount')}
              buttonColor='orange-button'
            />
          </div>
          <div className='col-12'>
            <SubmitButton
              onClick={closeModal}
              buttonMessage={t('common.cancel')}
              buttonColor='navy-button'
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

DeleteAccountModal.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    is_last_family_admin: PropTypes.bool,
  }).isRequired,
  isOwnAccount: PropTypes.bool.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  passwordError: PropTypes.string.isRequired,
  handlePasswordChange: PropTypes.func.isRequired,
  handleDeleteAccount: PropTypes.func.isRequired,
}

export default DeleteAccountModal
